import * as Units from '@/lib/units';

export function isGenericMetric(part){
   if(part && part.details && part.details["Series"]){
    return (
      part.details["Series"].toLowerCase().includes("metric") ||
      part.details["Series"].toLowerCase().includes("all")
    )
  }
  return false
}

export function isGenericImperial(part){
  if(part && part.details && part.details["Series"]){
    return (
      part.details["Series"].toLowerCase().includes("fractional") || 
      part.details["Series"].toLowerCase().includes("all")
    );
  }
  return false;
}

export function isMetric(part){
  if(part && part.details && part.details["Series"]){
    return (
      part.details["Series"].toLowerCase().includes("20") || 
      part.details["Series"].toLowerCase().includes("25") || 
      part.details["Series"].toLowerCase().includes("30") || 
      part.details["Series"].toLowerCase().includes("40") || 
      part.details["Series"].toLowerCase().includes("45") || 
      part.details["Series"].toLowerCase().includes("metric") ||
      part.details["Series"].toLowerCase().includes("all")
    );
  }
  return false
}

export function isImperial(part){
  if(part && part.details && part.details["Series"]){
    return (
      part.details["Series"].toLowerCase().includes("10") || 
      part.details["Series"].toLowerCase().includes("15") || 
      part.details["Series"].toLowerCase().includes("fractional") || 
      part.details["Series"].toLowerCase().includes("all")
    );
  }
  return false;
}
